import { Component } from '@theme/component';

/**
 * Starts ambassador videos from their custom thumbnail controls.
 *
 * @extends {Component}
 */
class AmbassadorVideos extends Component {
  /**
   * @param {MouseEvent} event
   */
  startVideo(event) {
    const trigger = event.target;
    if (!(trigger instanceof HTMLButtonElement)) return;

    const card = trigger.closest('[data-ambassador-video-card]');
    const video = card?.querySelector('video');
    if (!(card instanceof HTMLElement) || !(video instanceof HTMLVideoElement)) return;

    for (const otherVideo of this.querySelectorAll('video')) {
      if (otherVideo !== video && !otherVideo.paused) otherVideo.pause();
    }

    card.classList.add('is-playing');
    video.controls = true;
    video.focus({ preventScroll: true });

    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => card.classList.remove('is-playing'));
    }
  }
}

if (!customElements.get('ambassador-videos')) {
  customElements.define('ambassador-videos', AmbassadorVideos);
}
